// extracted by mini-css-extract-plugin
export default {"todo-list":"TodoList_todo-list__Mv4RG","done":"TodoList_done__rYFI1","remove":"TodoList_remove__3j88Z"};